import type { NestedFilter } from '@@partner:types:graphql'
import type { FilterConfig } from '@components/common/filter/FilterConfig'
import type { RsuiteColor } from '@@partner:types:app'

import React, { useCallback } from 'react'
import { Tag } from 'rsuite'
import { SHOP } from '@hive/status'

import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { prepareShopsFilter } from '@@partner:helpers/shop'

export interface ShopsFiltersType {
  name: string
  address: string
  statuses: number[]
  showArchived: boolean
}

export interface ShopsFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

const AVAILABLE_SHOP_STATUSES: { value: number; label: string; color: RsuiteColor }[] = [
  { value: SHOP.ENABLED, label: 'Включён', color: 'green' },
  { value: SHOP.DISABLED, label: 'Отключён', color: 'red' }
]

const defaultFilter: ShopsFiltersType = {
  name: '',
  address: '',
  statuses: [],
  showArchived: false
}

const filterConfig: FilterConfig[] = [
  createFilter.text('name', 'Название магазина'),
  createFilter.text('address', 'Адрес магазина'),
  createFilter.multiselect('statuses', AVAILABLE_SHOP_STATUSES, 'Статус', {
    searchable: false,
    renderMenuItem: (label, item) => (
      <Tag key={item?.value} color={item?.color}>
        {label}
      </Tag>
    )
  }),
  createFilter.checkbox('showArchived', 'Показать архивные')
]

export default function ShopsFilter ({ onFilterChanged }: ShopsFilterProps) {
  const handleSearch = useCallback((state: ShopsFiltersType) => {
    onFilterChanged(prepareShopsFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel<ShopsFiltersType>
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSearch}
    />
  )
}
